import React from "react";
import { Check } from "lucide-react";
import { CONFIG } from "../config";
import { Reveal } from "../hooks/useReveal";

const POINTS = [
  "10 mg Platinum per XPTY",
  "Fractional exposure by precise metal weight",
  "Built on Solana",
  "Programmable on-chain settlement",
];

export default function AboutXPTY() {
  return (
    <section className="w-full py-[80px] lg:py-[160px]">
      <div className="mx-auto max-w-[1280px] px-5 sm:px-8 lg:px-[64px]">
        <div className="grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <Reveal>
              <span className="micro-label">About {CONFIG.token}</span>
              <h2 className="mt-5 text-[32px] sm:text-[42px] lg:text-[52px] font-medium tracking-[-0.02em] leading-[1.05] text-[#F1F2EF]">
                Physical Platinum.
                <br />
                <span className="text-[#B5BAB7]">Digitally represented.</span>
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <Reveal delay={0.08}>
              <p className="text-[16px] sm:text-[18px] leading-[1.65] text-[#A0A5A2] max-w-[600px]">
                {CONFIG.token} represents Platinum through {CONFIG.company}’s Real
                World Asset infrastructure. Each {CONFIG.token} corresponds to
                precisely 10 milligrams of Platinum within the {CONFIG.token}
                {" "}framework, enabling fractional representation through modern
                on-chain infrastructure.
              </p>
            </Reveal>
            <div className="mt-10 border-t hairline">
              {POINTS.map((p, i) => (
                <Reveal key={p} delay={0.05 * i}>
                  <div className="flex items-center gap-4 py-4 border-b hairline">
                    <Check size={15} strokeWidth={2} className="text-[#B5BAB7]" />
                    <span className="text-[15px] text-[#F1F2EF]">{p}</span>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
